import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import clearAuthHeaderOn401 from '@utils/api/cd4pe/clearAuthHeaderOn401';

const queryCache = new QueryCache({ onError: clearAuthHeaderOn401 });
const mutationCache = new MutationCache({ onError: clearAuthHeaderOn401 });

const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

export default queryClient;
